import { useFetchCategoryQuery } from "@domains/common/networks/category/categoryQueries";

import * as S from "./CategoryLabel.style";

interface CategoryLabelProps {
  type?: number;
}

/**
 * @example
 *  "1": "🥟 Food/Drink",
 *  "2": "🎨 Arts/Cultures",
 *  "3": "⚾️ Outdoors Activities",
 *  "4": "👬 Socializing"
 */
const CategoryLabel = ({ type }: CategoryLabelProps) => {
  const { data: category } = useFetchCategoryQuery();

  return (
    <S.Label name="xs">
      {category && type ? category[type] : "undefined category"}
    </S.Label>
  );
};

export default CategoryLabel;
